export const Sales = [
  { title: 'Max LP Token Entry', number: '0.592347414033' },
  {
    title: 'Total Committed',
    number: '-$18.846.227'
  },
  {
    title: 'Fund to Raise',
    number: '$750.000'
  },
  {
    title: 'Cake to Burn',
    number: '375.000'
  },
  {
    title: 'Price per KALM',
    number: '$2'
  }
]
